import { Component } from '@angular/core';

@Component({
  selector: 'app-table-view',
  template: `<app-chart-output></app-chart-output>`,
  styleUrls: []
})
export class TableViewComponent {

}
